/**
 * 學門(📖)—— 學習端入口整併(spec ★定案)。
 *
 * 吃掉舊入口:課程(學科練習)+ 口說(收英語區)。**不重寫**既有功能,只重組入口:
 *   - 主路徑 = 課程(`renderAcademy` 經 main.ts 的 onCourses)。看真課本單元、學每一課。
 *   - 英語口說(`runOralExam`)收進「英語區」,≤3 tap(door → 此卡 → 口試)。
 *
 * 視覺 = 學術風(門色墨綠強調)。學習/遊戲分離:純學習側,絕不碰 commanderXp /
 * 戰鬥數值。
 */

import { pageShell, academicCard } from '../ui/components';
import { DOORS } from './doors';

/** 學門動作。`onCourses` / `onOral` 由 main.ts 接 setMode('academy' / 'oral-exam')。 */
export interface LearnDoorActions {
  onCourses: () => void;
  onOral: () => void;
  onBack: () => void;
}

export function runLearnDoor(container: HTMLElement, actions: LearnDoorActions): void {
  container.innerHTML = '';
  const spec = DOORS.learn;
  const shell = pageShell(container, {
    title: '📖 學',
    subtitle: '看真課本單元,一課一課學。英語口說也在這裡。',
    onBack: actions.onBack,
  });
  shell.root.style.setProperty('--door-accent', spec.accent);

  const root = document.createElement('div');
  root.className = 'learn-door';
  root.setAttribute('data-testid', 'learn-door');
  root.style.cssText = 'display:flex;flex-direction:column;gap:14px;';
  shell.body.appendChild(root);

  const courses = academicCard({
    icon: '📚',
    label: '看課本學每一課',
    sub: '挑科目 → 挑單元 → 學知識點',
    onClick: () => {
      shell.unmount();
      actions.onCourses();
    },
  });
  courses.id = 'learn-courses';
  courses.classList.add('ef-card--accent');
  courses.style.setProperty('--door-accent', spec.accent);
  root.appendChild(courses);

  const oral = academicCard({
    icon: '🎤',
    label: '英語口說',
    sub: '朗讀 / 家庭介紹 / 問答,錄音聽自己',
    onClick: () => {
      shell.unmount();
      actions.onOral();
    },
  });
  oral.id = 'learn-oral';
  oral.classList.add('ef-card--accent');
  oral.style.setProperty('--door-accent', spec.accent);
  root.appendChild(oral);
}
